import { tokenAliasOrValue } from "./base";
import { z } from "zod";
export const FontValue = z.unknown();
export const FontTokenData = tokenAliasOrValue(FontValue);
